import { Component, Input, SimpleChanges, OnChanges } from '@angular/core';
import { FbDashboardSmallTilesService } from './fb-dashboard-small-tiles.service';
import { take } from 'rxjs/operators';
import * as moment from 'moment';

@Component({
  selector: 'app-fb-dashboard-small-tiles',
  templateUrl: './fb-dashboard-small-tiles.component.html',
  styleUrls: ['./fb-dashboard-small-tiles.component.scss']
})
export class FbDashboardSmallTilesComponent implements OnChanges {
  @Input() content: {
    type: string,
    title: string,
    bgcolor: string,
    apiValue: string,
    valueColor?: string,
    borderRadius?: string
  };
  count: number;

  constructor(
    private fbDashboardSmallTilesService: FbDashboardSmallTilesService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.content && changes.content.currentValue?.apiValue !== changes.content.previousValue?.apiValue) {
      this.fetchCount();
    }
  }

  private fetchCount(): void {
    if (this.content?.apiValue) {
      // Regular expression to match the date pattern inside curly braces
      const datePattern = /\{date-(.*?)\}/;
      let replacedApiValue;
      // Extract the date pattern from the input string
      const match = this.content.apiValue.match(datePattern);

      if (match) {
        const dateString = match[1]; // Extracted date string
        const formattedDate = moment().format(dateString);

        // Replace the date pattern with the formatted date
        replacedApiValue = this.content.apiValue.replace(datePattern, formattedDate);
      } else {
        replacedApiValue = this.content.apiValue;
      }

      this.fbDashboardSmallTilesService.getCount(replacedApiValue)
        .pipe(take(1))
        .subscribe((count: number) => {
          this.count = count;
        });
    }
  }

}
